<template>
    <div class="productlist">
        <ul>
                    <li v-for="(item,index) in productList" v-if="languageType == 1&&item.enName == ''?false:true" :key="index" @click="toDetail(item.name)">
                            <div class="picter">
                                    <img :src="item.picUrl"/>
                            </div>
                            <div class="text">
                                    <p>{{languageType == 0? item.name :item.enName}}</p>
                                    <span>{{ languageType == 0?item.detail:item.enDetail }}</span>
                            </div>
                    </li>
                    <div class="clear"></div>
        </ul>
        <div class="page">
                    <el-pagination
                    background
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="totalCount">
                    </el-pagination>
                    <div class="mount">
                        <span v-if="languageType == 0">共 {{ totalPage }} 页</span>
                        <span v-else>Total {{totalPage}} Page</span>
                    </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType','categoryId'],
    data () {
        return {
            pageIndex: 1,
            pageSize: 12,
            totalPage:0,
            totalCount:0,
            categoryid:'',
            productList:[],
        }
    },
    created () {
        this.getCategoryList()
    },
    methods:{
        init (id) {
            this.getProductList()
        },
        getCategoryList () {
            this.$http({
                url: this.$http.adornUrl('/web/category/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.categoryid = data.page.list[0].id
                    this.getProductList()
                } else {
                }
            })
        },
        getProductList () {
            this.$http({
                url: this.$http.adornUrl('/web/product/list'),
                method: 'post',
                data: {
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    'categoryId':this.categoryId == ''?this.categoryid:this.categoryId
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.productList = data.page.list
                    this.totalCount = data.page.totalCount
                    this.totalPage = data.page.totalPage
                } else {
                    this.productList = []
                    this.totalCount = 0
                }
            })
        },
        // 当前页
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getProductList()
        },
        toDetail (name) {
            this.$router.push({ name:'productdetail',query:{key:JSON.stringify(name)}})
        }
    }
}
</script>

<style lang="less" scoped>
  .productlist {
      ul {
                width: 1320px;
                margin: 0 auto;
                margin-top: 60px;
                position: relative;
                z-index: 100;
                li:nth-child(3n+0){
                    margin-right: 0
                }
                li {
                            width: 432px;
                            height: 344px;
                            float: left;
                            background-color: #fff;
                            margin-right: 12px;
                            margin-bottom: 12px;
                            position: relative;
                            cursor: pointer;
                            box-shadow:-3px 0 5px rgba(222, 222, 222, 0.8),3px 0 5px rgba(222, 222, 222, 0.8),
                            0 -3px 5px rgba(222, 222, 222, 0.8), 0 3px 5px rgba(222, 222, 222, 0.8);
                            .picter {
                                height: 241px;
                                img {
                                    width: 430px;
                                    height: 240px;
                                    margin-top: 1px;
                                }
                            }
                            .text {
                                width: 432px;
                                height: 103px;
                                position: relative;
                                text-align: left;
                                &:hover {
                                    p {
                                        color: #e21711;
                                    }
                                    span {
                                        color: #e21711;
                                    }
                                }
                                p {
                                    font-size: 24px;
                                    color: #000000;
                                    padding: 18px 0 0 20px;
                                }
                                span {
                                    font-size: 16px;
                                    color: #606060;
                                    margin: 5px 0 0px 20px;
                                    overflow: hidden;
                                    display: block;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }
                            .text::before {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 1px;
                                width: 430px;
                                height: 1px;
                                background-color: #d6d6d6;
                            }
                        }
                        li::after {
                            content: '';
                            display: block;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 100%;
                            height: 9px;
                            background-color: #e21711;
                        }
                        .clear {
                            clear: both;
                            float:none;
                        }
            }
            .page {
                margin-top: 90px;
                line-height: 30px;
                position: relative;
                margin-bottom: 90px;
                z-index: 99;
                .el-pagination.is-background .el-pager li:not(.disabled).active{
                    background-color:#e21711
                }
                .mount {
                    display: inline-block;
                    span {
                        font-size: 15px;
                        color: #606060;
                    }
                }

            }
  }
</style>


// WEBPACK FOOTER //
// src/components/productlist.vue